import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import svarynLogo from '../assets/only_name_black.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleNavClick = (path) => {
    if (location.pathname === path) {
      scrollToTop();
    }
    setIsOpen(false);
  };

  return (
    <nav className={`fixed w-full top-0 z-50 transition-all duration-300 ${
      scrolled 
        ? 'bg-amber-50/95 backdrop-blur-md shadow-lg border-b border-amber-200' 
        : 'bg-amber-50 shadow-md border-b border-amber-200'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo - Leftmost and vertically centered */}
          <div className="flex-shrink-0 flex items-center">
            <Link to="/" className="flex items-center group" onClick={scrollToTop}>
              <img 
                src={svarynLogo} 
                alt="Svaryn Jewellery" 
                className="h-auto w-auto transition-transform duration-300 group-hover:scale-105"
                style={{ maxHeight: '180px' }}
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <Link 
                to="/" 
                className="navbar-link"
                onClick={() => handleNavClick('/')}
              >
                Home
              </Link>
              <Link 
                to="/products" 
                className="navbar-link"
                onClick={() => handleNavClick('/products')}
              >
                Products
              </Link>
              <Link 
                to="/about" 
                className="navbar-link"
                onClick={() => handleNavClick('/about')}
              >
                About Us
              </Link>
              <Link 
                to="/contact" 
                className="navbar-link"
                onClick={() => handleNavClick('/contact')}
              >
                Contact
              </Link>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-black hover:text-amber-700 focus:outline-none focus:text-amber-700 transition-colors duration-300 p-2 rounded-lg hover:bg-amber-100"
            >
              <svg className="h-6 w-6 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden ${
        isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
      }`}>
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-amber-100 shadow-lg border-t border-amber-200">
          <Link 
            to="/" 
            className="block px-3 py-2 rounded-md text-base font-medium text-black hover:text-amber-700 hover:bg-amber-200 transition-all duration-300"
            onClick={() => handleNavClick('/')}
          >
            Home
          </Link>
          <Link 
            to="/products" 
            className="block px-3 py-2 rounded-md text-base font-medium text-black hover:text-amber-700 hover:bg-amber-200 transition-all duration-300"
            onClick={() => handleNavClick('/products')}
          >
            Products
          </Link>
          <Link 
            to="/about" 
            className="block px-3 py-2 rounded-md text-base font-medium text-black hover:text-amber-700 hover:bg-amber-200 transition-all duration-300"
            onClick={() => handleNavClick('/about')}
          >
            About Us
          </Link>
          <Link 
            to="/contact" 
            className="block px-3 py-2 rounded-md text-base font-medium text-black hover:text-amber-700 hover:bg-amber-200 transition-all duration-300"
            onClick={() => handleNavClick('/contact')}
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
